import { storefront } from './sections/storefront.de';
import { account } from './sections/account.de';
import { admin } from './sections/admin.de';

export const de = { ...storefront, ...account, ...admin };
